export default "__VITE_ASSET__DDU4vB0a__"